import axios from "axios";
// import config from "../config/config";
//var cert = require("../CertificateRC/RCcert.pem");

export const EncryptWitchTokenLSKO = async (data, certificate) => {
  //const cert = btoa(certificate);

  const dataReq = data;
  var options = {
    async: true,
    crossDomain: true,
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
    },
    data: dataReq,
    cert: certificate,
    json: true,
  };
  let response = axios.post(`/encryptwithtoken`, options);
  response.then((res) => {
    //console.log(res);
  });
  return response;
};

export const VerifyCertificate = async (chain, cert, crl) => {
  // //console.log(cert)
  // //console.log(crl)
  // //console.log(chain)

  try {
    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      chain: btoa(unescape(encodeURIComponent(chain))),
      certificate: btoa(unescape(encodeURIComponent(cert))),
      revoke: btoa(unescape(encodeURIComponent(crl))),
      json: true,
    };
    // //console.log(options);
    return await axios
      .post(`/verifycertificate`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const VerifySignP7S = async (sign, data, cert) => {
  try {
    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      p7s: sign,
      bytes: data,

      certificate: btoa(unescape(encodeURIComponent(cert))),
      json: true,
    };
    return await axios
      .post(`/verifysignp7s`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const GenEncryptKey = async () => {
  try {
    var options = {
      async: true,
      crossDomain: true,
    };
    return await axios
      .get(`/genencryptkey`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Encryptdata = async (alg, data, pubkey) => {
  try {
    //console.log(alg);
    //console.log(data);
    //console.log(pubkey);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      alg: alg,
      data: data,
      pubkey: pubkey,
      json: true,
    };
    return await axios
      .post(`/encryptdata`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Decryptdata = async (alg, data, token, privKey, password) => {
  try {
    //console.log(alg);
    //console.log(data);
    //console.log(token);

    //console.log(privKey);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      alg: alg,
      data: data,
      token: token,
      privKey: privKey,
      password: password,
      json: true,
    };
    return await axios
      .post(`/decryptdata`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Encrypt = async (alg, data, privkey) => {
  try {
    //console.log(alg);
    //console.log(data);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      alg: alg,
      data: data,
      privkey: privkey,
      json: true,
    };
    return await axios
      .post(`/encrypt`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Decrypt = async (alg, data, privKey) => {
  try {
    //console.log(alg);
    //console.log(data);
    //console.log(privKey);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      alg: alg,
      data: data,
      privKey: privKey,
      json: true,
    };
    return await axios
      .post(`/decrypt`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Protect = async (alg, data, privKey, password, pubKey) => {
  try {
    //console.log(alg);
    //console.log(data);
    //console.log(privKey);
    //console.log(password);
    //console.log(pubKey);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      alg: alg,
      data: data,
      privKey: privKey,
      password: password,
      pubKey: pubKey,
      json: true,
    };
    return await axios
      .post(`/protect`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Unprotect = async (
  alg,
  data,
  privKey,
  password,
  pubKey,
  token,
  sign
) => {
  try {
    //console.log(alg);
    //console.log(data);
    //console.log(privKey);
    //console.log(password);
    //console.log(pubKey);
    //console.log(token);
    //console.log(sign);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      alg: alg,
      data: data,
      privKey: privKey,
      password: password,
      pubKey: pubKey,
      token: token,
      sign: sign,
      json: true,
    };
    return await axios
      .post(`/unprotect`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const KeyProtect = async (privKey, password) => {
  try {
    //console.log(privKey);
    //console.log(password);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },

      privKey: privKey,
      password: password,
      json: true,
    };
    return await axios
      .post(`/keyprotect`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const KeyUnprotect = async (privKey, password) => {
  try {
    //console.log(privKey);
    //console.log(password);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },

      privKey: privKey,
      password: password,
      json: true,
    };
    return await axios
      .post(`/keyunprotect`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const SetPrivateKey = async (privKey, level) => {
  try {
    //console.log(privKey.length);
    //console.log(level);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },

      privKey: privKey,
      level: level,
      json: true,
    };
    return await axios
      .post(`/setprivatekey`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const CreateMac = async (data) => {
  try {
    //console.log(data);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
      json: true,
    };
    return await axios
      .post(`/createmac`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const CreateHmac = async (data) => {
  try {
    //console.log(data);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
      json: true,
    };
    return await axios
      .post(`/createhmac`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Createtoken = async (keyfortoken, pubkey) => {
  try {
    //console.log(keyfortoken);
    //console.log(pubkey);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      keyfortoken: keyfortoken,
      pubkey: pubkey,
      json: true,
    };
    return await axios
      .post(`/createtoken`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const Decodetoken = async (token, privkey, password) => {
  try {
    //console.log(token);
    //console.log(privkey);
    //console.log(password);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      token: token,
      privkey: privkey,
      password: password,
      json: true,
    };
    return await axios
      .post(`/decodetoken`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const CreateDigest = (data, algoritm, data_type) => {
  try {
    return new Promise((resolve, reject) => {

      const formData = new FormData();

      var options = {
        async: true,
        crossDomain: true,
        method: "post",
        headers: {
          "Content-Type": `multipart/form-data`,
        }
      };

      if (data_type === "text") {
        formData.append("text", btoa(unescape(encodeURIComponent(data))));
        formData.append("dataType", data_type);
        formData.append("alg", algoritm);
        options.data = formData
      } else if (data_type === "file") {
        formData.append("file", data, data.name);
        formData.append("dataType", data_type);
        formData.append("alg", algoritm);
        options.data = formData
      }

      axios(`/createdigest`, options)
        .then((result) => {
          if (result.status == 200) {
            resolve(result);
          } else {
            var error = new Error(this.statusText);
            error.code = this.status;
            reject(error);
          }
        })
        .catch((err) => {
          return err.response;
        });
    })

  } catch (error) {
    console.log(error);
  }
};

export const GenPrivateKey = async (level, password) => {
  try {
    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      level: btoa(unescape(encodeURIComponent(level))),
      password: btoa(unescape(encodeURIComponent(password))),

      json: true,
    };
    return await axios
      .post(`/genprivkey`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const CreateSignP7S = async (data, privKey, password, cert) => {
  try {
    //console.log(data);
    //console.log(privKey);
    //console.log(password);
    //console.log(cert);

    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
      privateKey: privKey,
      password: password,
      certificate: cert,

      json: true,
    };
    return await axios
      .post(`/createsignp7s`, options)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};
export const GenRequest = async (subject, privKey, password) => {
  try {
    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      subject: btoa(unescape(encodeURIComponent(subject))),
      privateKey: btoa(unescape(encodeURIComponent(privKey))),
      password: btoa(unescape(encodeURIComponent(password))),

      json: true,
    };
    return await axios
      .post(`/genrequest`, options)
      .then((result) => {
        //console.log(result);
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const CreateCertificate = async (request, privKey, password) => {
  try {
    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      request: btoa(unescape(encodeURIComponent(request))),
      privKey: btoa(unescape(encodeURIComponent(privKey))),
      password: btoa(unescape(encodeURIComponent(password))),

      json: true,
    };
    return await axios
      .post(`/certificate`, options)
      .then((result) => {
        //console.log(result);
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};

export const CreateCRL = async (cert, privKey, password) => {
  try {
    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      cert: btoa(unescape(encodeURIComponent(cert))),
      privKey: btoa(unescape(encodeURIComponent(privKey))),
      password: btoa(unescape(encodeURIComponent(password))),

      json: true,
    };
    return await axios
      .post(`/createcrl`, options)
      .then((result) => {
        //console.log(result);
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};
export const VerifyCRL = async (crl, cert) => {
  try {
    var options = {
      async: true,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      },
      crl: btoa(unescape(encodeURIComponent(crl))),
      cert: btoa(unescape(encodeURIComponent(cert))),
      json: true,
    };
    return await axios
      .post(`/verifycrl`, options)
      .then((result) => {
        //console.log(result);
        return result;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (error) {
    //console.log(error);
  }
};


// export const EncryptWitchToken = async (data, cer) => {
//   //const cert = btoa(certificate);

//   var cert = require("../CertificateRC/RCcert1.pem");

//   const dataReq = data;
//   const certificate = axios.get(cert);
//   return certificate.then(result => {
//   console.log(result);
//     var options = {
//       async: true,
//       crossDomain: true,
//       headers: {
//         Accept: "*/*",
//         "Content-Type": "application/json"
//       },
//       data: dataReq,
//       cert: btoa(result.data),
//       json: true
//     };
//     let response = axios.post(`/encryptwithtoken`, options);
//     response.then(res => {
//       //console.log(res)
//     });
//     return response;
//   });
// };

// export const DecryptWitchToken = async (dataUser, hash, hashrequest) => {
//   const hashData = hash;
//   const data = dataUser;
//   const hashreq = hashrequest;

//   var options = {
//     async: true,
//     crossDomain: true,
//     headers: {
//       Accept: "*/*",
//       "Content-Type": "application/json"
//     },
//     hash: hashData,
//     hashrequest: hashreq,

//     encryptData: data,
//     json: true
//   };
//   let response = await axios.post(`/decryptanswer`, options);

//   //console.log(response.data);
//   return response;
// };
